const isDevelopment =
  process.env.NODE_ENV === "development" || process.env.DEBUG_PROD === "true";

export default isDevelopment;
